import axiosIns from "@/libs/axios";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchUsers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          //.get("user", { params: queryParams })
          .get("user", { params: queryParams })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    // Courses
    fetchCourses(ctx, params) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("courses", { params })
          .then((r) => resolve(r))
          .catch((e) => reject(e));
      });
    },
    saveCourse(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveCourse", data)
          .then((r) => resolve(r))
          .catch((e) => reject(e));
      });
    },
    getCourseById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getCourseById/${id}`)
          .then((r) => resolve(r))
          .catch((e) => reject(e));
      });
    },
    updateCourse(ctx, { id, data }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateCourse/${id}`, data)
          .then((r) => resolve(r))
          .catch((e) => reject(e));
      });
    },
    deleteCourseById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteCourse/${id}`)
          .then((r) => resolve(r))
          .catch((e) => reject(e));
      });
    },
    updateCourseAudience(ctx, { id, data }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`courses/${id}/audience`, data)
          .then((r) => resolve(r))
          .catch((e) => reject(e));
      });
    },
    fetchCourseOptions() {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("courses/options")
          .then((r) => resolve(r))
          .catch((e) => reject(e));
      });
    },

    // Venues
    fetchVenues(ctx, params) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("venues", { params })
          .then((r) => resolve(r))
          .catch((e) => reject(e));
      });
    },
    createVenue(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("venues", data)
          .then((r) => resolve(r))
          .catch((e) => reject(e));
      });
    },
    updateVenue(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`venues/${data.id}`, data)
          .then((r) => resolve(r))
          .catch((e) => reject(e));
      });
    },
    deleteVenue(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`venues/${id}`)
          .then((r) => resolve(r))
          .catch((e) => reject(e));
      });
    },

    // Trainers
    fetchTrainers(ctx, params) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("trainers", { params })
          .then((r) => resolve(r))
          .catch((e) => reject(e));
      });
    },
    createTrainer(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("trainers", data)
          .then((r) => resolve(r))
          .catch((e) => reject(e));
      });
    },
    updateTrainer(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`trainers/${data.id}`, data)
          .then((r) => resolve(r))
          .catch((e) => reject(e));
      });
    },
    deleteTrainer(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`trainers/${id}`)
          .then((r) => resolve(r))
          .catch((e) => reject(e));
      });
    },
    createTrainerWithFile(ctx, formData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("trainers", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((r) => resolve(r))
          .catch((e) => reject(e));
      });
    },
    updateTrainerWithFile(ctx, { id, formData }) {
      return new Promise((resolve, reject) => {
        // Laravel requires POST for FormData with _method=PUT
        formData.append("_method", "PUT");
        axiosIns
          .post(`trainers/${id}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((r) => resolve(r))
          .catch((e) => reject(e));
      });
    },
    downloadTrainerCV(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`trainers/${id}/download-cv`, {
            responseType: "blob",
          })
          .then((r) => resolve(r))
          .catch((e) => reject(e));
      });
    },

    // Venues
    fetchVenues(ctx, params) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("venues", { params })
          .then((r) => resolve(r))
          .catch((e) => reject(e));
      });
    },
    workingGroupUsers(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          //.get("user", { params: queryParams })
          .get("workingGroupUsers")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    /********* Roles */
    /*********** */
    fetchRoles(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("roles", { params: queryParams })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },
    fetchPermissions(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("permissions", { params: queryParams })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },
    addRole(ctx, role) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("roles/store", role)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    updateRole(payload) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`roles/${payload.role}`, payload.permissions)
          .then((response) => {
            resolve(response);
            //    showToast("success");
          })
          .catch((error) => reject(error));
      });
    },

    // DEPARTMENT

    getAllCompanies(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("getCompany", { params: queryParams })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getCompanyById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getCompanyById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateCompany(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateCompany/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteCompany(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteCompany/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    saveCompany(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveCompany", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //Sites

        getSiteById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getSiteById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateSite(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateSite/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteSite(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`deleteSite/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    saveSite(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveSite", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    takeSiteOffline(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("takeOffline", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    restoreSiteOnline(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("restoreOffline", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getOfflinePeriods(ctx, siteId) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getOfflinePeriods/${siteId}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },


     getAllSites(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("getAllSites", { params: queryParams })
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

        takeSiteOffline(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("takeOffline", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    restoreSiteOnline(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("restoreOffline", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getOfflinePeriods(ctx, siteId) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getOfflinePeriods/${siteId}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //Pillar

    savePillar(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("savePillar", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    checkOrderNumber(ctx, order) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`checkPillarOrderNumber`, { order })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllPillars(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("pillars")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getPillarById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getPillarById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updatePillar(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updatePillar/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deletePillar(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deletePillar/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //pillar title

    savePillarTitle(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("savePillarTitle", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllPillarTitles(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("pillarTitles")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getPillarTitleById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getPillarTitleById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updatePillarTitle(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updatePillarTitle/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    changeStatusPillarTitle(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`changeStatusPillarTitle/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deletePillarTitle(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deletePillarTitle/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    checkPillarTitleUsage(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`checkPillarTitleUsage/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //Objective

    saveObjective(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveObjective", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllObjectives(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("objectives")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getObjectiveById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getObjectiveById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateObjective(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateObjective/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    changeStatusObjective(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`changeStatusObjective/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteObjective(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteObjective/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    checkObjectiveUsage(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`checkObjectiveUsage/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //Action

    saveAction(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveAction", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllActions(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("actions")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getActionById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getActionById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateAction(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateAction/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    changeStatusAction(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`changeStatusAction/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteAction(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteAction/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    checkActionUsage(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`checkActionUsage/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //KPI

    saveKPI(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveKPI", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllKPIs(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("kpis")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getKPIById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getKPIById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateKPI(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateKPI/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    changeStatusKPI(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`changeStatusKPI/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteKPI(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteKPI/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    checkKPIUsage(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`checkKPIUsage/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //Narrative

    saveNarrative(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveNarrative", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllNarratives(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("narratives")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getNarrativeById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getNarrativeById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateNarrative(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateNarrative/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteNarrative(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteNarrative/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //CSF

    saveCSF(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveCSF", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllCSFs(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("csfs")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getCSFById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getCSFById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateCSF(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateCSF/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteCSF(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteCSF/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //Owner

    saveOwner(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveOwner", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllOwners(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("owners")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getOwnerById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getOwnerById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateOwner(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateOwner/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    changeStatusOwner(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`changeStatusOwner/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteOwner(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteOwner/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    checkOwnerUsage(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`checkOwnerUsage/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //Priority

    savePriority(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("savePriority", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllPriorities(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns

          .get("priorities")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getPriorityById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getPriorityById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updatePriority(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updatePriority/${metData.id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deletePriority(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deletePriority/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    //Working Group

    saveWorkingGroup(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveWorkingGroup", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllWorkingGroups(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("workingGroups")
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getWorkingGroupById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`getWorkingGroupById/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    updateWorkingGroup(ctx, metData) {
      const id = metData instanceof FormData ? metData.get("id") : metData.id;
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`updateWorkingGroup/${id}`, metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    changeStatusWorkingGroup(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`changeStatusWorkingGroup/${metData.id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    deleteWorkingGroup(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteWorkingGroup/${metData.id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    checkWorkingGroupUsage(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`checkWorkingGroupUsage/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    getWorkingGroupToolSubsections(ctx, wg_id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`/workingGroupTools/subsection-inputs/${wg_id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    // Timeline Actions
    getAllTimelineActions(ctx, metData) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("getAllTimelineActions", metData)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    getWgOwnerOptions(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("getWgOwnerOptions")
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    removeWorkingGroupDocument(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`workingGroup/removeWorkingGroupDocument/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    // ── Risk Categories ──────────────────────────────────────────────
    getAllRiskCategories(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns.get('risk-categories-settings').then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    getRiskCategoryById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`getRiskCategoryById/${id}`).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    saveRiskCategory(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.post('saveRiskCategory', data).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    updateRiskCategory(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.put(`updateRiskCategory/${data.id}`, data).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    deleteRiskCategory(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.delete(`deleteRiskCategory/${data.id}`).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    checkRiskCategoryOrderNumber(ctx, order) {
      return new Promise((resolve, reject) => {
        axiosIns.post('checkRiskCategoryOrderNumber', { order }).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },

    // ── Risk Objectives ("Risk" field) ───────────────────────────────
    getAllRiskObjectives(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns.get('risk-objectives-settings').then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    getRiskObjectiveById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`getRiskObjectiveById/${id}`).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    saveRiskObjective(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.post('saveRiskObjective', data).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    updateRiskObjective(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.put(`updateRiskObjective/${data.id}`, data).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    deleteRiskObjective(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.delete(`deleteRiskObjective/${data.id}`).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },

    // ── Risk Impacts ("Potential Impact" field) ──────────────────────
    getAllRiskImpacts(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns.get('risk-impacts-settings').then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    getRiskImpactById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`getRiskImpactById/${id}`).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    saveRiskImpact(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.post('saveRiskImpact', data).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    updateRiskImpact(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.put(`updateRiskImpact/${data.id}`, data).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    deleteRiskImpact(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.delete(`deleteRiskImpact/${data.id}`).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },

    // ── Risk Mitigation Actions ──
    getAllRiskMitigationActions(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns.get('risk-mitigation-actions-settings').then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    getRiskMitigationActionById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`getRiskMitigationActionById/${id}`).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    saveRiskMitigationAction(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.post('saveRiskMitigationAction', data).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    updateRiskMitigationAction(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.put(`updateRiskMitigationAction/${data.id}`, data).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    deleteRiskMitigationAction(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.delete(`deleteRiskMitigationAction/${data.id}`).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },

    // ── Risk Future Actions ──
    getAllRiskFutureActions(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns.get('risk-future-actions-settings').then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    getRiskFutureActionById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axiosIns.get(`getRiskFutureActionById/${id}`).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    saveRiskFutureAction(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.post('saveRiskFutureAction', data).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    updateRiskFutureAction(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.put(`updateRiskFutureAction/${data.id}`, data).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
    deleteRiskFutureAction(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns.delete(`deleteRiskFutureAction/${data.id}`).then((r) => resolve(r)).catch((e) => reject(e));
      });
    },
  },
};
